angular.module("ainapp")
    .controller("addOpeningBalanceController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Add Opening Balance";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.TokenInfo = AuthenticationService.getTokenInfo();

            $scope.VDesign = {};
            MainService.VoucherDesignsbyType("Opening Balance").then(function (response) {
                $scope.VDesign = response.data;
            });

            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Opening Balance").then(function (response) {
                $scope.PrintSetting = response.data;
            });

            $scope.TableDesign = {};
            $scope.ColumnWidth = null;
            MainService.TableDesignsbyVoucher("Opening Balance").then(function (response) {
                if (response.data != null && response.data != "") {
                    $scope.TableDesign = response.data;
                    $scope.ColumnWidth = JSON.parse(response.data.ColumnWidth);
                }
            });

            $scope.getExtramasters();

       
            $scope.loadVoucher = function (data) {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetOB(data).then(function (response) {
                    if (response.data) {
                        $scope.UpdateDetails(response.data[0]);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                })
            }



            $scope.UpdateDetails = function (data) {

                $scope.CurrentOB = data;
                $scope.CurrentOB.Date = new Date($scope.CurrentOB.Date);
                $scope.VoucherDocs = data.VoucherDocs;

                if ($scope.CurrentOB.InvDate != null) {
                    $scope.CurrentOB.InvDate = new Date($scope.CurrentOB.InvDate);
                }
                if ($scope.CurrentOB.DueDate != null) {
                    $scope.CurrentOB.DueDate = new Date($scope.CurrentOB.DueDate);
                }

                angular.forEach(data.OpeningBalanceCosts, function (e) {
                    angular.forEach($scope.CostCenters, function (a) {
                        if (e.CostCenter.ParentId == a.CostCenterId) {
                            a.SelectedCostCenterId = e.CostCenter.Id;
                        }
                    })
                })


                $scope.tempTotalQty = 0;
                $scope.tempUnitPrice = 0;
                $scope.tempGross = 0;
                $scope.tempDiscount = 0;
                $scope.tempVat = 0;

                angular.forEach($scope.CurrentOB.OpeningBalanceDetails, function (e) {
                    $scope.tempTotalQty = $scope.tempTotalQty + e.Quantity;
                    $scope.tempUnitPrice = $scope.tempUnitPrice + e.UnitPrice;
                    $scope.tempGross = $scope.tempGross + e.Total;
                    $scope.tempDiscount = $scope.tempDiscount + e.Discount;
                    $scope.tempVat = $scope.tempVat + e.TaxValue;


                    if (e.InvDate != null && e.InvDate != undefined) {
                        e.InvDate = new Date(e.InvDate);
                    }
                    if (e.DueDate != null && e.DueDate != undefined) {
                        e.DueDate = new Date(e.DueDate);
                    }

                    var costs = angular.copy($scope.CostCenters);
                    if (e.OpeningBalanceCosts.length > 0) {
                        angular.forEach(e.OpeningBalanceCosts, function (ee) {
                            angular.forEach(costs, function (a) {
                                if (ee.CostCenter.ParentId == a.CostCenterId) {
                                    a.SelectedCostCenterId = ee.CostCenter.Id;
                                }
                            })
                            e.CostCenters = angular.copy(costs);
                        })
                    } else {
                        e.CostCenters = angular.copy($scope.CostCenters);
                    }
 

                });

                if (data.OpeningBalanceDetails.length <= 5) {

                    var temp2 = 5 - data.OpeningBalanceDetails.length;

                    for (var i = 0; i < temp2; i++) {

                        var OpeningBalanceDetails = {
                            Id: "",
                            AccountId: "",
                            CreditAmount: 0,
                            DebitAmount: 0,
                            Account: {},
                            CostCenters: angular.copy($scope.CostCenters),

                        }

                        $scope.CurrentOB.OpeningBalanceDetails.push(OpeningBalanceDetails);
                    }
                }


            }

            $scope.expand = function () {
                $scope.expandView = !$scope.expandView;
            }

            $scope.VoucherSet = {};
            MainService.VoucherAccountsbyType('Opening Balance').then(function (response) {
                $scope.VoucherSet = response.data;
            })

            $scope.Currencies = [];
            MainService.CurrencyInDropdown().then(function (response) {
                $scope.Currencies = response.data;
            })

            $scope.tableReorderColumnArray = [];
            $scope.ReArrangeTable = function () {
                $scope.RearrangeReqired = false;
                $scope.tableReorderColumnArray = [];

                if ($scope.ColumnWidth != null) {
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        let key = cell.getAttribute('data-key');
                        if ($scope.ColumnWidth[key] !== undefined) {
                            cell.style.width = $scope.ColumnWidth[key] + "px";
                        }
                    });
                } else {
                    toastr.info("Table Width Adjustment Empty, Applying Default Width")
                    document.querySelectorAll('#rearrangeTable th[data-key], #rearrangeTable td[data-key]').forEach(cell => {
                        cell.style.width = "100px";
                    });
                }
            };

            $scope.init = function () {

                $scope.expandView = false;

                $scope.ViewVal = 0;
                $scope.Load = false;
                $scope.ErrorText = "";

                $scope.print = {
                    IsPrint: false,
                }

                $scope.CurrentOB = {
                    Date: new Date(),
                    VoucherNumber: "",
                    OpeningBalanceDetails: [],
                    TotalCredit: 0,
                    TotalDebit: 0,
                    Remarks: "",
                    Id: "",
                    InvNo: "",
                    DueDate: null,
                    InvDate: null,
                }


                for (var i = 0; i < 10; i++) {

                    var OpeningBalanceDetails = {
                        Id: "",
                        AccountId: "",
                        CreditAmount: 0,
                        DebitAmount: 0,
                        Account: {},
                        Flats: [],
                        CostCenters: angular.copy($scope.CostCenters),

                    }

                    $scope.CurrentOB.OpeningBalanceDetails.push(OpeningBalanceDetails);
                }

                //                $.LoadingOverlay("show", {
                //                    image: "images/load.gif",
                //                });
                //                MainService.OBForCurrentFinancialYear().then(function (response) {
                //                    if (response.data != null) {
                //                        $scope.UpdateDetails(response.data); 
                //                    } else {
                //                        MainService.GetNextOBMasterNo().then(function (response) {
                //                            $scope.CurrentOB.VoucherNumber = response.data;
                //                            MainService.getCurrentFinancialYear().then(function (response) {
                //                                $scope.CurrentOB.Date = new Date(response.data.StartDate);
                //                            });
                //                        });
                //                    }
                //                    $.LoadingOverlay("hide");
                //                }, function (err) {
                //                    $.LoadingOverlay("hide");
                //                    toastr.error("Network Error");
                //                })

                $scope.CompanyProfile = {};
                if ($stateParams.VoucherId > 0) {
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CurrentOB.Date = new Date($scope.CompanyProfile.DefaultFinancialYear.StartDate);
                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Opening Balance").then(function (response) {
                            $scope.CostCenters = response.data;
                            $scope.loadVoucher($stateParams.VoucherId);
                        });
                    })
                } else {
                    $scope.CompanyProfile = {};
                    MainService.GetCompanyProfile().then(function (response) {
                        $scope.CompanyProfile = response.data;
                        $scope.CurrentOB.Date = new Date($scope.CompanyProfile.DefaultFinancialYear.StartDate);
                        $scope.CurrentOB.CurrencyId = $scope.CompanyProfile.BaseCurrencyId;

                        $scope.CostCenters = {};
                        MainService.CostCentersInVoucher("Opening Balance").then(function (response) {
                            $scope.CostCenters = response.data;
                            angular.forEach($scope.CurrentOB.OpeningBalanceDetails, function (e) {
                                e.CostCenters = angular.copy($scope.CostCenters);
                            })
                        });

                    })

                    MainService.GetNextOBMasterNo().then(function (response) {
                        $scope.CurrentOB.VoucherNumber = response.data;
                    });
                }

                setTimeout(function () {
                    $scope.ReArrangeTable();
                }, 2000);

            }
            $scope.init();

            $scope.AccountAutocompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length == 0) {
                            var temp = {
                                value: "",
                                operator: "contains",
                                field: "Name",
                                ignoreCase: true
                            }
                            o.data.filter.filters.push(temp);
                        }
                        o.data.LoadType = "Body";
                        o.data.VoucherName = "Opening Balance";
                        MainService.LoadAccountsInAutoComplete(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.NetworkErrorLan);
                        });
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.AccountAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Name",
                dataTextField: "Name",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };

            $scope.AccountCodeAutocompleteOptions = {
                valuePrimitive: true,
                dataValueField: "AccountCode",
                dataTextField: "AccountCode",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.AccountId = data.Id;
                    $scope.SelectedCE.Account = data;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.AccountAutocompleteDataSource
            };


            $scope.getBills = function (data) {

                $scope.SelectedCE = data;

                if (data.Account.TypeName == "Creditors" || data.Account.TypeName == "Debtors") {
                    data.UnassignedBillsArray = [];
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.GetPendingBillAnalysis(data.AccountId, "Receipt").then(function (response) {
                        if (response.data != null) {
                            if (response.data.length > 0) {
                                data.UnassignedBillsArray = response.data;

                                if (data.Id > 0) {
                                    if (data.UnassignedBillsArrays.length > 0) {
                                        angular.forEach(data.UnassignedBillsArrays, function (e) {
                                            data.UnassignedBillsArray.unshift(e);
                                        })
                                    }
                                }

                                // angular.forEach(data.Bills, function (e) {
                                //     e.Adjustment = 0;
                                //     e.TotalBalance = e.BalanceAmount - e.Adjustment;
                                // })

                                $scope.SelectedCE.AdjustedTotal = 0;
                                $scope.SelectedCE.BalanceAdjusted = data.Amount;
                                $scope.SelectedCE.UnAssignedAdjusted = 0;

                                //$scope.SelectedCE.GrandTotal = data.Amount;

                                angular.forEach(data.UnassignedBillsArray, function (e) {
                                    $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                })

                                // $scope.autoAdjust();
                                $('#unassignedModal').modal('show');

                            }
                            else {
                                if (data.Id > 0) {
                                    if (data.UnassignedBillsArrays.length > 0) {

                                        $scope.SelectedCE.UnassignedBillsArray = data.UnassignedBillsArrays;
                                        $scope.SelectedCE.AdjustedTotal = 0;
                                        $scope.SelectedCE.BalanceAdjusted = data.GrandTotal;
                                        $scope.SelectedCE.UnAssignedAdjusted = 0;
                                        angular.forEach(data.UnassignedBillsArray, function (e) {
                                            $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                            $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                                            $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.BalanceAdjusted - e.Adjustment;
                                        })
                                        $('#unassignedModal').modal('show');

                                    } else {
                                        //$scope.SaveWithConfirm();
                                        $('#unassignedModal').modal('show');
                                    }
                                } else {
                                    // $scope.SaveWithConfirm();
                                    $('#unassignedModal').modal('show');
                                }
                            }
                        } else {

                            if (data.Id > 0) {
                                if (data.UnassignedBillsArrays.length > 0) {

                                    $scope.SelectedCE.UnassignedBillsArray = data.UnassignedBillsArrays;

                                    $scope.SelectedCE.AdjustedTotal = 0;
                                    $scope.SelectedCE.BalanceAdjusted = data.GrandTotal;
                                    $scope.SelectedCE.UnAssignedAdjusted = 0;
                                    angular.forEach(data.UnassignedBillsArray, function (e) {
                                        $scope.SelectedCE.UnAssignedAdjusted = $scope.SelectedCE.UnAssignedAdjusted + e.BalanceAmount;
                                        $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                                        $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.BalanceAdjusted - e.Adjustment;
                                    })
                                    $('#unassignedModal').modal('show');

                                } else {
                                    toastr.warning("Unassigned Bills Not Found !");
                                }
                            } else {
                                toastr.warning("Unassigned Bills Not Found !");
                            }

                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $.LoadingOverlay("hide");
                        toastr.error("Network Error");
                    });

                }

            }

            $scope.matchrow = function (index) {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.BalanceAdjusted = 0;
                var row = $scope.SelectedCE.UnassignedBillsArray[index];
                row.Adjustment = 0;
                var tt = $scope.SelectedCE.Amount;
                var assigned = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    assigned = assigned + e.Adjustment;
                })
                var bal = tt - assigned;
                if (bal > 0 && row.BalanceAmount > bal) {
                    row.Adjustment = bal;
                }
                if (bal > 0 && bal >= row.BalanceAmount) {
                    row.Adjustment = row.BalanceAmount;
                }
                $scope.SelectedCE.AdjustedTotal = assigned + row.Adjustment;
                $scope.SelectedCE.BalanceAdjusted = tt - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.unmatchrow = function (index) {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                var row = $scope.SelectedCE.UnassignedBillsArray[index];
                row.Adjustment = 0;
                var tt = $scope.SelectedCE.Amount;
                var assigned = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    assigned = assigned + e.Adjustment;
                })
                var bal = tt - assigned;
                $scope.SelectedCE.AdjustedTotal = assigned + row.Adjustment;
                $scope.SelectedCE.BalanceAdjusted = tt - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.autoAdjust = function () {

                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                var tmp = $scope.SelectedCE.Amount;

                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    if (tmp > 0) {
                        if (e.BalanceAmount > tmp) {
                            e.Adjustment = tmp;
                            tmp = 0;
                        } else {
                            e.Adjustment = e.BalanceAmount;
                            tmp = tmp - e.BalanceAmount;
                        }
                        tmp = Math.round(tmp * 100) / 100;
                        //  e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    }
                    $scope.SelectedCE.AdjustedTotal = $scope.SelectedCE.AdjustedTotal + e.Adjustment;
                })
                $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.GrandTotal - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.removeAdjustment = function () {
                $scope.SelectedCE.AdjustedTotal = 0;
                $scope.SelectedCE.BalanceAdjusted = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    e.Adjustment = 0;
                })
                $scope.SelectedCE.BalanceAdjusted = $scope.SelectedCE.GrandTotal - $scope.SelectedCE.AdjustedTotal;
            }

            $scope.validateBill = function () {
                var totaladj = 0;
                angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    totaladj = totaladj + e.Adjustment;
                })
                if (totaladj > $scope.SelectedCE.Amount) {
                    toastr.warning("Amount exeeding, Values will reset");
                    // angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                    //     e.Adjustment = 0;
                    //     e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    // })
                } else {
                    angular.forEach($scope.SelectedCE.UnassignedBillsArray, function (e) {
                        e.TotalBalance = e.BalanceAmount - e.Adjustment;
                    })
                }
            }



            $scope.click = function (data, temp) {

                $scope.SelectedCE = data;

                if (data.CreditAmount > 0 && data.DebitAmount > 0) {

                    toastr.warning($scope.LanguageData.InvalidDetails);
                    data.DebitAmount = 0;
                    data.CreditAmount = 0;
                }

                $scope.CurrentOB.TotalCredit = 0;
                $scope.CurrentOB.TotalDebit = 0;

                angular.forEach($scope.CurrentOB.OpeningBalanceDetails, function (e) {
                    $scope.CurrentOB.TotalCredit = $scope.CurrentOB.TotalCredit + e.CreditAmount;
                    $scope.CurrentOB.TotalDebit = $scope.CurrentOB.TotalDebit + e.DebitAmount;
                });

                $scope.CurrentOB.TotalDebit = Math.round($scope.CurrentOB.TotalDebit * 100) / 100;
                $scope.CurrentOB.TotalCredit = Math.round($scope.CurrentOB.TotalCredit * 100) / 100;

                var a = $scope.CurrentOB.OpeningBalanceDetails.indexOf(data);

                if (($scope.CurrentOB.OpeningBalanceDetails.length - 1) == a) {
                    var OpeningBalanceDetails = {
                        Id: "",
                        AccountId: "",
                        CreditAmount: 0,
                        DebitAmount: 0,
                        Account: {},
                    }
                    $scope.CurrentOB.OpeningBalanceDetails.push(OpeningBalanceDetails);
                }
            }

            $scope.IsSavePrint = false;

            $scope.SaveVocuher = function (pval) {

                $scope.IsSavePrint = false;
                if (pval == 2) {
                    $scope.IsSavePrint = true;
                }

                $scope.CurrentOB.DateString = $scope.extractDate($scope.CurrentOB.Date);
                if ($scope.CurrentOB.Field16 != null) {
                    $scope.CurrentOB.F16DateString = $scope.extractDate($scope.CurrentOB.Field16);
                }
                if ($scope.CurrentOB.Field17 != null) {
                    $scope.CurrentOB.F17DateString = $scope.extractDate($scope.CurrentOB.Field17);
                }
                if ($scope.CurrentOB.Field18 != null) {
                    $scope.CurrentOB.F18DateString = $scope.extractDate($scope.CurrentOB.Field18);
                }
                if ($scope.CurrentOB.Field19 != null) {
                    $scope.CurrentOB.F19DateString = $scope.extractDate($scope.CurrentOB.Field19);
                }
                if ($scope.CurrentOB.Field20 != null) {
                    $scope.CurrentOB.F20DateString = $scope.extractDate($scope.CurrentOB.Field20);
                }

                if ($scope.CurrentOB.DueDate != null) {
                    $scope.CurrentOB.DueDateString = $scope.extractDate($scope.CurrentOB.DueDate);
                    $scope.CurrentOB.IsDueDate = true;
                }

                if ($scope.CurrentOB.InvDate != null) {
                    $scope.CurrentOB.InvDateString = $scope.extractDate($scope.CurrentOB.InvDate);
                    $scope.CurrentOB.IsInvDate = true;
                }

                $scope.ErrorText = "";

                count = 0;
                count2 = 0;
                var costval = 0;
                angular.forEach($scope.CurrentOB.OpeningBalanceDetails, function (e) {
                    if ((e.AccountId == "" && (e.CreditAmount > 0 || e.DebitAmount > 0)) || (e.AccountId > 0 && e.CreditAmount == 0 && e.DebitAmount == 0)) {
                        count = count + 1;
                    } else if (e.AccountId == "" && e.CreditAmount == 0 && e.DebitAmount == 0) {
                        count2 = count2 + 1;
                    }

                    if (e.Field16 != null) {
                        e.F16DateString = $scope.extractDate(e.Field16);
                    }
                    if (e.Field17 != null) {
                        e.F17DateString = $scope.extractDate(e.Field17);
                    }
                    if (e.Field18 != null) {
                        e.F18DateString = $scope.extractDate(e.Field18);
                    }
                    if (e.Field19 != null) {
                        e.F19DateString = $scope.extractDate(e.Field19);
                    }
                    if (e.Field20 != null) {
                        e.F20DateString = $scope.extractDate(e.Field20);
                    }


                    if (e.AccountId > 0 && (e.DebitAmount > 0 || e.CreditAmount > 0)) {
                        e.OpeningBalanceCosts = [];
                        angular.forEach(e.CostCenters, function (a) {
                            if (a.Section == "Body") {
                                if (a.IsMandatory && !a.SelectedCostCenterId > 0) {
                                    $scope.ErrorText = $scope.LanguageData.CostCenterNotSelectedFor + a.CostCenter.Name;
                                } else {
                                    if (a.SelectedCostCenterId > 0) {
                                        var cst = {
                                            CostCenterId: a.SelectedCostCenterId,
                                        }
                                        e.OpeningBalanceCosts.push(cst);
                                        console.log(e);
                                    }
                                }
                            }
                        })
                    }

                    
                    if (e.UnassignedBillsArray != null) {
                        var tot = 0;
                        angular.forEach(e.UnassignedBillsArray, function (bil) {
                            tot = tot + bil.Adjustment;
                        })
                        tot = Math.round(tot * 100) / 100;
                        if (e.Amount < tot) {
                            $scope.ErrorText = "Adjusted Amount Invalid Please Check " + e.Account.Name;
                        }else{
                            e.UnassignedBillsArrays = e.UnassignedBillsArray;
                        }
                    }

                })

                $scope.CurrentOB.OpeningBalanceCosts = [];
                angular.forEach($scope.CostCenters, function (e) {
                    if (e.Section == "Head") {
                        if (e.IsMandatory && !e.SelectedCostCenterId > 0) {
                            $scope.ErrorText = $scope.LanguageData.CostCenterNotSelectedFor + e.CostCenter.Name;
                        } else {
                            if (e.SelectedCostCenterId > 0) {
                                var cst = {
                                    CostCenterId: e.SelectedCostCenterId,
                                }
                                $scope.CurrentOB.OpeningBalanceCosts.push(cst);
                            }
                        }
                    }
                })


                //                if (count > 0) {
                //                    $scope.ErrorText = "Invalid Details";
                //                }
                if (count2 == $scope.CurrentOB.OpeningBalanceDetails.length) {
                    $scope.ErrorText = $scope.LanguageData.InvalidDetails;
                }

                //                if ($scope.CurrentOB.TotalCredit != $scope.CurrentOB.TotalDebit) {
                //                    $scope.ErrorText = "Invalid Details";
                //                }

                if ($scope.VDesign != null) {
                    if ($scope.VoucherDocs.length == 0 && $scope.VDesign.IsAttachmentMandatory) {
                        $scope.ErrorText = "Attachment Missing";
                    }
                }

                if (!$scope.PageAccessInfo.IsAdd && !$scope.CurrentOB.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToAddData);
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.CurrentOB.Id > 0) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToEditData);

                } else {
                    if ($scope.ErrorText == "") {
                        $('#saveModal').modal('show');
                    } else {
                        toastr.warning($scope.ErrorText);
                    }
                }


            }

            $scope.SaveWithConfirm = function () {
                console.log($scope.CurrentOB);
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.CurrentOB.VoucherDocs = $scope.VoucherDocs;

                angular.forEach($scope.CurrentOB.OpeningBalanceDetails, function (e) {

                    if (e.InvDate != null && e.InvDate != "" && e.InvDate != undefined) {
                        e.InvDateString = $scope.extractDate(e.InvDate);
                    }

                    if (e.DueDate != null && e.DueDate != "" && e.DueDate != undefined) {
                        e.DueDateString = $scope.extractDate(e.DueDate);
                    }

                })


                MainService.AddOpeningBalance($scope.CurrentOB).then(function (response) {
                    if (response.data.Message == "Success") {
                        $scope.Load = false;
                        toastr.success("Success");
                        $('#saveModal').modal('hide');
                        if ($scope.IsSavePrint == true) {
                            toastr.info("Printing");
                            $scope.PrintInvoice(response.data.Id, 'Opening Balance', $scope.CurrentOB.VoucherNumber);
                        }
                        $scope.refreshpageSave();
                    } else {
                        $scope.Load = false;
                        toastr.warning(response.data.Message);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.Load = false;
                });

            }


            $scope.refreshpageSave = function () {

                if ($stateParams.VoucherId > 0) {
                    $state.go("OpeningBalance");
                } else {
                    $scope.init();
                }

            }

            $scope.DeleteVoucher = function () {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    if ($scope.CurrentOB.Id > 0) {
                        $('#deleteModal').modal('show');
                    }

                }
            }




            $scope.DeleteWithConfirm = function () {
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteOpeningBalance($scope.CurrentOB.Id).then(function (response) {
                    if (response.data.Message == "Success") {
                        toastr.success("Deleted");
                        $scope.Load = false;
                        $('#deleteModal').modal('hide');
                        $state.go("OpeningBalance");
                    } else {
                        toastr.warning(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                    toastr.error($scope.LanguageData.NetworkError);
                })
            }


            $scope.getFlats = function (row) {
                $scope.Load = true;

                MainService.FlatsByBuildingId(row.BuildingId).then(function (response) {
                    row.Flats = response.data;
                    $scope.Load = false;

                }, function (err) {
                    $scope.Load = false;
                    toastr.error($scope.LanguageData.NetworkError);
                })
            }






            //// for context menu

            $scope.ClickedRow = {};
            $scope.ShowContextMenu = function (data) {
                $scope.ClickedRow = data;
            }

            $scope.InsertRow = function () {

                var OpeningBalanceDetails = {
                    Id: "",
                    AccountId: "",
                    CreditAmount: 0,
                    DebitAmount: 0,
                    Account: {},
                    Flats: [],
                    CostCenters: angular.copy($scope.CostCenters),

                }

                $scope.CurrentOB.OpeningBalanceDetails.push(OpeningBalanceDetails);

            }

            $scope.deleteRow = function () {
                var index = $scope.CurrentOB.OpeningBalanceDetails.indexOf($scope.ClickedRow);
                $scope.CurrentOB.OpeningBalanceDetails.splice(index, 1);

                $scope.CurrentOB.TotalCredit = 0;
                $scope.CurrentOB.TotalDebit = 0;


                angular.forEach($scope.CurrentOB.OpeningBalanceDetails, function (e) {

                    $scope.CurrentOB.TotalCredit = $scope.CurrentOB.TotalCredit + e.CreditAmount;
                    $scope.CurrentOB.TotalDebit = $scope.CurrentOB.TotalDebit + e.DebitAmount;

                });

            }

            $scope.GetBackOpeningBalance = function (type) {
                var temp = 0;
                if ($scope.CurrentOB.Id > 0) {
                    temp = $scope.CurrentOB.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackOpeningBalance(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data)
                    } else {
                        $scope.init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error($scope.LanguageData.NetworkError);
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }


            $scope.getAccountByName = function () {


                angular.forEach($scope.CurrentOB.OpeningBalanceDetails, function (e) {


                    if (e.AccountCode != null && e.AccountCode != "" && e.AccountCode != "" && e.AccountName !=
                        null && e.AccountName != "" && e.AccountName != "") {

                        var temp = {
                            Code: e.AccountCode,
                            Name: e.AccountName,
                        }
                        MainService.getAccountByName(temp).then(function (response) {
                            if (response.data) {
                                e.AccountId = response.data.Id;
                                e.Account = response.data;
                            } else {
                                toastr.warning($scope.LanguageData.AccountNotFound + e.AccountName);
                            }
                        }, function () {
                            toastr.error($scope.LanguageData.NetworkError);
                        })

                    }

                });

            }

            var oFileIn;

            $(function () {
                oFileIn = document.getElementById('my_file_input');
                if (oFileIn.addEventListener) {
                    oFileIn.addEventListener('change', filePicked, false);
                }
            });

            function filePicked(oEvent) {
                var oFile = oEvent.target.files[0];
                var sFilename = oFile.name;
                var reader = new FileReader();

                $scope.CurrentOB.OpeningBalanceDetails = [];

                reader.onload = function (e) {
                    var data = e.target.result;
                    var cfb = XLSX.read(data, {
                        type: 'binary'
                    });
                    console.log(cfb)
                    cfb.SheetNames.forEach(function (sheetName) {
                        var sCSV = XLS.utils.make_csv(cfb.Sheets[sheetName]);
                        var oJS = XLS.utils.sheet_to_json(cfb.Sheets[sheetName]);

                        var headers = Object.keys(oJS[0] || {});
                        var fixedColumns = ["AccountCode", "AccountName", "Debit", "Credit", "Remarks", "LPONo", "InvNo", "DueDate", "InvDate"];
                        var dynamicColumns = headers.filter(h => !fixedColumns.includes(h));

                        angular.forEach(oJS, function (e) {

                            e.AccountCode = e.AccountCode;
                            e.AccountName = e.AccountName;
                            e.AccountId = "";
                            e.Account = {};
                            e.CreditAmount = parseFloat(e.Credit);
                            e.DebitAmount = parseFloat(e.Debit);
                            e.Remarks = e.Remarks;
                            e.LPONo = e.LPONo;
                            e.InvNo = e.InvNo;
                            e.Remarks = e.Remarks;

                            if (e.DueDate != null && e.DueDate != "") {
                                var dateString = e.DueDate;
                                var [day, month, year] = dateString.split("/").map(Number);
                                var date = new Date(year, month - 1, day);
                                e.DueDate = date;
                            } else {
                                e.DueDate = null;
                            }

                            if (e.InvDate != null && e.InvDate != "") {
                                var dateString = e.InvDate;
                                var [day, month, year] = dateString.split("/").map(Number);
                                var date = new Date(year, month - 1, day);
                                e.InvDate = date;
                            } else {
                                e.InvDate = null;
                            }

                            e.DynamicFields = [];
                            dynamicColumns.forEach(col => {
                                e.DynamicFields.push(e[col]);
                            });

                            e.CostCenters = angular.copy($scope.CostCenters);
                            angular.forEach(e.CostCenters, function (d) {
                                angular.forEach(d.CostCenters, function (dd) {
                                    angular.forEach(e.DynamicFields, function (ddd) {
                                        if(ddd == dd.Name){
                                            d.SelectedCostCenterId = dd.Id;
                                        }
                                    })
                                })
                            })

                        });

                        $scope.CurrentOB.OpeningBalanceDetails = oJS;

                        var length = 10 - $scope.CurrentOB.OpeningBalanceDetails.length;

                        for (var i = 0; i < length; i++) {

                            var OpeningBalanceDetails = {
                                Id: "",
                                AccountId: "",
                                CreditAmount: 0,
                                DebitAmount: 0,
                                Account: {},
                                Flats: [],
                                CostCenters: angular.copy($scope.CostCenters),
                            }

                            $scope.CurrentOB.OpeningBalanceDetails.push(OpeningBalanceDetails);
                        }

                        $scope.$apply();
                        $scope.getAccountByName();

                    });
                };

                reader.readAsBinaryString(oFile);



            }



            $scope.$on('refreshCostCenterDir', function (e, id) {
                angular.forEach($scope.CostCenters, function (cost) {
                    if (cost.CostCenterId == id) {
                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });
                        MainService.CostCenterSubList(id).then(function (response) {
                            if (response.data != null) {
                                cost.CostCenters = response.data;
                                angular.forEach($scope.CurrentOB.OpeningBalanceDetails, function (d) {
                                    angular.forEach(d.CostCenters, function (dd) {
                                        if (dd.CostCenterId == id) {
                                            dd.CostCenters = response.data;
                                        }
                                    })
                                })
                            }
                            $.LoadingOverlay("hide");
                        }, function () {
                            toastr.error($scope.LanguageData.NetworkError);
                            $.LoadingOverlay("hide");
                        })
                    }
                })
            });


            /////////////////// Attachment //////////////////

            $scope.VoucherDocs = [];
            $scope.initAttachment = function () {
                $scope.VAttachment = {
                    ExpiryDate: null,
                    FileName: "",
                    FilePath: "",
                    Remarks: "",
                    IsActive: true,
                }
            }
            $scope.initAttachment();

            $scope.addAttachmentList = function () {
                if ($scope.VAttachment.FilePath == "") {
                    toastr.warning("Upload File");
                } else if ($scope.VAttachment.FileName == "") {
                    toastr.warning("Enter File Name");
                } else {
                    $scope.VoucherDocs.push($scope.VAttachment);
                    $scope.initAttachment();
                }
            }

            $scope.removeAttachmentRow = function (data) {
                data.IsActive = false;
            }


            // file upload
            $scope.files = [];
            $scope.getFileDetails = function (e) {
                $scope.files = [];
                $scope.$apply(function () {
                    for (var i = 0; i < e.files.length; i++) {
                        $scope.files.push(e.files[i])
                    }
                });
                $scope.Load = true;
                $scope.uploadFiles();
            };
            $scope.remove = function (file) {
                var index = $scope.files.indexOf(file);
                $scope.files.splice(index, 1);
            }
            $scope.uploadFiles = function () {
                var data = new FormData();
                for (var i in $scope.files) {
                    data.append("uploadedFile", $scope.files[i]);
                }
                var objXhr = new XMLHttpRequest();
                objXhr.onreadystatechange = function () {
                    if (objXhr.readyState == XMLHttpRequest.DONE) {
                        if (objXhr.responseText != null && objXhr.responseText != "") {
                            $scope.VAttachment.FilePath = objXhr.responseText;
                            if ($scope.VAttachment.FilePath.includes("error")) {
                                $scope.VAttachment.FilePath = "";
                                toastr.error($scope.LanguageData.UploadError);
                            } else {
                                $scope.VAttachment.FilePath = objXhr.responseText;
                                toastr.success($scope.LanguageData.FileUploaded);
                            }
                        } else {

                        }
                    }
                }
                // objXhr.addEventListener("progress", updateProgress, false);
                objXhr.addEventListener("load", transferComplete, false);
                if ($scope.files.length > 0) {
                    toastr.info($scope.LanguageData.FileUploadingPleaseWait);
                    objXhr.open("POST", config.basePath + "UploadFiles");
                    objXhr.send(data);
                } else {
                    toastr.error($scope.LanguageData.UploadError);
                }
            }
            //function updateProgress(e) {
            //    if (e.lengthComputable) {
            //        document.getElementById('pro').setAttribute('value', e.loaded);
            //        document.getElementById('pro').setAttribute('max', e.total);
            //    }
            //}
            function transferComplete(e) {
                $scope.Load = false;
            }


            $scope.FieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoComplete(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.FieldAutoCompleteOptions11 = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentOB.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions12 = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentOB.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions13 = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentOB.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions14 = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentOB.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };
            $scope.FieldAutoCompleteOptions15 = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.CurrentOB.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.FieldAutoCompleteDataSource
            };

            $scope.DFieldAutoCompleteDataSource = {
                serverFiltering: true,
                transport: {
                    read: function (o) {
                        if (o.data.filter.filters.length > 0) {
                            o.data.FieldVoucherName = "Credit Note SR";
                            if (o.data.filter.filters.length == 0) {
                                var temp = {
                                    value: "",
                                    operator: "contains",
                                    field: "Name",
                                    ignoreCase: true
                                }
                                o.data.filter.filters.push(temp);
                            }
                            MainService.FieldAutoCompleteDetail(o.data).then(function (response) {
                                o.success(response.data);
                            }, function (err) {
                                o.success({
                                    Data: []
                                });
                                toastr.error("Network Error");
                            });
                        } else {
                            o.success({
                                Data: []
                            });
                        }
                    }
                },
                schema: {
                    data: "Data"
                },
                pageSize: 10
            };

            $scope.D11AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field11",
                dataTextField: "Field11",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field11 = data.Field11;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D12AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field12",
                dataTextField: "Field12",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field12 = data.Field12;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D13AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field13",
                dataTextField: "Field13",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field13 = data.Field13;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D14AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field14",
                dataTextField: "Field14",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field14 = data.Field14;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };

            $scope.D15AutoCompleteOptions = {
                valuePrimitive: true,
                dataValueField: "Field15",
                dataTextField: "Field15",
                filter: "contains",
                placeholder: "",
                minLength: 2,
                select: function (data) {
                    var data = this.dataItem(data.item.index());
                    $scope.SelectedCE.Field15 = data.Field15;
                    $scope.$apply();
                },
                minLength: 2,
                dataSource: $scope.DFieldAutoCompleteDataSource
            };



        }])
